import { apiClientConfiguration } from "app/constants/apiConst";
import {
  FirmwareApiV2FirmwareTypeGetRequest,
  FirmwareApiV2FirmwareTypePostRequest,
  FirmwareApiV2FirmwareTypeIdRequestUploadUrlGetRequest,
  UploadUrlInfo,
  FirmwareApi,
  FirmwareApiV2FirmwareTypeIdDeleteRequest,
  FirmwareApiV2FirmwareTypeLatestGetRequest,
} from "@generated/v2";
import axios, { AxiosRequestConfig } from "axios";
import { UploadFile } from "antd/lib/upload/interface";

const api = new FirmwareApi(apiClientConfiguration);

// GET LIST
export const readerFirmwareGet = (
  requestParameters?: FirmwareApiV2FirmwareTypeGetRequest,
  options?: any
) => api.v2FirmwareTypeGet(requestParameters, options);

// Get firmware upload URL
export const requestUploadUrl = (
  requestParameters: FirmwareApiV2FirmwareTypeIdRequestUploadUrlGetRequest,
  options?: any
) => api.v2FirmwareTypeIdRequestUploadUrlGet(requestParameters, options);

// Get latest version
export const readerFirmwareLatestVersionGet = (
  requestParameters: FirmwareApiV2FirmwareTypeLatestGetRequest,
  options?: any
) => api.v2FirmwareTypeLatestGet(requestParameters, options);

// POST
export const readerVersionSave = (
  requestParameters: FirmwareApiV2FirmwareTypePostRequest,
  options?: any
) => api.v2FirmwareTypePost(requestParameters, options);

// DELETE firmware
export const readerversionDelete = (
  requestParameters: FirmwareApiV2FirmwareTypeIdDeleteRequest,
  options?: any
) => api.v2FirmwareTypeIdDelete(requestParameters, options);

// PUT file
export const uploadVersionFile = (
  file: UploadFile<any>,
  requestParameters: UploadUrlInfo
) => {
  // Form key/value headers from array
  const headers = requestParameters.headers?.reduce(
    (o, key) => ({ ...o, [key.name!]: key.value }),
    {}
  );

  // TODO(Hassan): Change method from type string to type Method
  //@ts-ignore
  const config: AxiosRequestConfig = {
    ...requestParameters,
    headers,
    data: file,
  };

  return axios(config);
};
